import { Response } from '@angular/http';
import { Subject } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { RequestConfig } from '../../rest/rest.request';
import { RequestMethod } from '@angular/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CustomHttp } from '../../../common/http/custom.http';

@Injectable({
    providedIn: 'root'
})
export class HeaderService {
    private GET_NUMBER_NOTIFICATIONS = new RequestConfig('HEADER01', 'application/json', true, RequestMethod.Get, '/notification/number/{idUser}');
    private GET_NOTIFICATIONS = new RequestConfig('HEADER02', 'application/json', true, RequestMethod.Get, '/notification/{idUser}');
    private PUT_NOTIFICATION = new RequestConfig('HEADER03', 'application/json', true, RequestMethod.Put, '/notification/{idNotification}');
    private PUT_NOTIFICATION_STATUS = new RequestConfig('HEADER03', 'application/json', true, RequestMethod.Put, '/notification/status');
    private GET_NOTIFICATION_CATEGORIES = new RequestConfig('HEADER04', 'application/json', true, RequestMethod.Get, '/notification/categories');

    modalNotifyUpdateClose: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    itemEmit: Subject<any> = new BehaviorSubject<any>(null);
    currentMessage: Observable<any> = this.itemEmit.asObservable();
    notificationsAlertModal: any = [];
    isOpenedNotifyModal: boolean = false;
    constructor(private http: CustomHttp) {
    }

    emitItem(item: any): void {
        this.itemEmit.next(item);
    }

    getNumberNotifications(idUser: number, idTypes: NotificationType[], idPriorities: NotificationPriority[], status: NotificationStatus[]): Observable<NumberNotifiView[]>{
        let body = {idType: idTypes, idPriority: idPriorities, status: status };
        return this.http.sendRequest(this.GET_NUMBER_NOTIFICATIONS, body, idUser )
            .map((res) => res.json())
            .catch((error) => this.http.handleError(error));
    }

    getNotifications(idUser: number, idTypes: NotificationType[], idPriorities: NotificationPriority[], status: NotificationStatus[], save?: boolean): Observable<NotificationView[]>{
        let body = {idType: idTypes, idPriority: idPriorities, status: status };
        return this.http.sendRequest(this.GET_NOTIFICATIONS, body, idUser )
            .map((res) =>{
                if(save)
                {
                    this.notificationsAlertModal = res.json();
                }
                return res.json()
            })
            .catch((error) => this.http.handleError(error));
    }

    updateNotification(notificationUpdate: NotificationUpdate): Observable<Response> {
        return this.http.sendRequest(this.PUT_NOTIFICATION, notificationUpdate,notificationUpdate.notification[0])
            .catch(this.http.handleError);
    }

    updateNotificationSimple(notificationUpdate: any): Observable<Response> {
        return this.http.sendRequest(this.PUT_NOTIFICATION, notificationUpdate, notificationUpdate.idNotification)
            .catch(this.http.handleError);
    }

    updateNotificationStatus(notificationStatusUpdate: NotificationStatusUpdate): Observable<any> {
        return this.http.sendRequest(this.PUT_NOTIFICATION_STATUS, notificationStatusUpdate)
            .catch(this.http.handleError);
    }

    getNotificationCategories(notificationType: NotificationType): Observable<NotificationCategory[]> {
        switch(notificationType) {
            case NotificationType.GEOFENCES:
                return of([
                    {
                        idCategory: 1,
                        categoryName: 'Mal clima'
                    },
                    {
                        idCategory: 2,
                        categoryName: 'Accidente vial'
                    },
                    {
                        idCategory: 3,
                        categoryName: 'Tráfico en la zona'
                    }
                ] as NotificationCategory[]);
            case NotificationType.ALERT:
                return of([
                    {
                        idCategory: 1,
                        categoryName: 'Secuestro'
                    },
                    {
                        idCategory: 2,
                        categoryName: 'Asalto'
                    },
                    {
                        idCategory: 3,
                        categoryName: 'Agresión física'
                    }
                ] as NotificationCategory[]);
            default:
                return of([]);
        }
    }

    updateLeidaNotifyAndEmitRefresh(notification:any): void{
        let newArray = [];
        this.notificationsAlertModal.forEach((element:any) => {
            if(element.idNotification == notification.idNotification){
                let newElement: any = {...element}
                newElement.status = 2;
                newArray.push(newElement);
            }
            else
            {
                newArray.push(element);
            }
        });
        this.notificationsAlertModal =  [];
        this.notificationsAlertModal =  [...newArray];
        this.modalNotifyUpdateClose.next(true);
    }
}

export class NumberNotifiView {
    idType: number;
    count: number;
}

export class NotificationView {
    idUserApp: number;
    userName: string;
    createDate: number;
    idType: NotificationType;
    idPriority: NotificationPriority;
    subject: string;
    status: NotificationStatus;
    channel: string;
    description: string;
    extraInfo: any[];
    idNotification?: string;
}

export class NotificationUpdate {
    notification: string[] = [];
    subject: string;
    idType?: NotificationType;
    idPriority?: NotificationPriority;
    description?: string;
    channel?: string;
    extraInfo?: any[];

    constructor(notification?: NotificationView) {
        if (notification) {
            this.notification = [
                notification.idNotification
                // idType: notification.idType,
                // createDate: notification.createDate
        ];
            this.subject = notification.subject;
        }
    }
}

export class NotificationStatusUpdate {
    updateDate: number;
    idStatus: NotificationStatus;
    notification: string[] = [];

    constructor(notification?: NotificationView) {
        this.updateDate = Date.now();

        if (notification) {
            this.notification = [
                notification.idNotification
               // idType: notification.idType,
               // createDate: notification.createDate
            ];
        }
    }
}

export interface NotificationForUpdate {
    createDate?: number;
    idType?: NotificationType;
    idNotification: string;
}

export interface NotificationCategory {
    idCategory: number;
    categoryName: string;
}

export enum NotificationType {
    NORMAL = 1,
    TICKET = 2,
    GPS = 3,
    SECURITY = 4,
    ALERT = 5,
    NO_SALE = 6,
    MAXTIME_ON_TICKET = 7,
    SPEED_ALERT = 8,
    GEOFENCES = 9,
    ONLY_ONE_DIRECTION = 10,
    ASIGNE_TASK= 11,
    SOLVE_TASK=12,
    TICKET_CHAT=13,
    TASK_CHAT=14,
    TIME_KILLED = 15,

    FOOD = 16,
    BATHROOM = 17,
    TRAFFIC = 18,
    FUEL_REFILL = 19,
    
    TRAFFIC_ACCIDENT = 20,
    VEHICLE_BREAKDOWN = 21,
    BAD_WEATHER = 22,
    CRIME = 23,
    ILLNESS = 24,
    WORK_AREA_INCIDENT = 25,
}

export enum NotificationStatus {
    NEW = 1,
    READED = 2,
    SOLVED = 3,
    DELETED = 4
}

export enum NotificationPriority {
    LOW = 1,
    MEDIUM = 2,
    HIGH = 3
}
